import { Injectable } from '@angular/core';
import { Documento } from 'src/app/shared/models/documento.model';
import { DocumentoAllegato } from '../shared/models/documentoAllegato.model';
import { DocumentoDestinatario } from '../shared/models/documentoDestinatario.model';
import { DocumentoRiproduzioneRow } from '../shared/models/documentoRiproduzione.model';
import { Indirizzo } from '../shared/models/indirizzo.model';
import { Posizione } from '../shared/models/posizione.model';
import { Riferimento } from '../shared/models/riferimento';

@Injectable({ providedIn: 'root' })
export class NuovoDocumentoService {
  public documento: Documento;
  public documentoDaTrasmettere: Documento;
  public documentoDaSpedire: Documento;
  public docId = 0;
  public posizione: Posizione[];
  public posizioneRiproduzione: Posizione[];
  public documentoRiproduzione: DocumentoRiproduzioneRow | undefined;
  public allegatiDaTrasmettere: DocumentoAllegato[];
  public entiRichiedenti: Indirizzo[];

  constructor() {
    this.documento = {} as Documento;
    this.documentoDaTrasmettere = {} as Documento;
    this.documentoDaSpedire = {} as Documento;
    this.posizione = [];
    this.posizioneRiproduzione = [];
    this.allegatiDaTrasmettere = [];
    this.entiRichiedenti = [];
  }

  init(): void {
    this.docId = 0;
    this.documento = {} as Documento;
    this.documentoDaTrasmettere = {} as Documento;
    this.documentoDaSpedire = {} as Documento;
    this.posizione = [];
    this.posizioneRiproduzione = [];
    this.allegatiDaTrasmettere = [];
    this.entiRichiedenti = [];
    this.documento.qualificaId = 1;
    this.documento.statoId = 1;
  }

  setPosizione(posizione: Posizione[]): void {
    this.posizione = posizione;
  }

  setPosizioneRiproduzione(posizione: Posizione[]): void {
    this.posizioneRiproduzione = posizione;
  }

  setPartenza(documentoArrivo: Documento): void {
    this.docId = documentoArrivo.documentoId;
    this.documento.posizioneId = documentoArrivo.posizioneId;
    this.documento.oggetto = documentoArrivo.oggetto;
    this.documento.arrivo = false;
    this.documento.classificaId = documentoArrivo.classificaId;
    this.documento.classificaOriginaleId = documentoArrivo.classificaOriginaleId || documentoArrivo.classificaId;
    this.documento.qualificaId = documentoArrivo.qualificaId;
    this.documento.esercitazione = documentoArrivo.esercitazione;
    this.documento.autoreId = documentoArrivo.autoreId;
    this.documento.ambito = documentoArrivo.ambito;
    this.documento.lingua = documentoArrivo.lingua;
    this.documento.paroleChiave = documentoArrivo.paroleChiave;
    this.documento.documentoAnalogico = documentoArrivo.documentoAnalogico;
    this.documento.prodottoSoftwareId = documentoArrivo.prodottoSoftwareId;
    this.documento.numeroPagine = documentoArrivo.numeroPagine;
    this.documento.organoSicurezzaOriginatore = documentoArrivo.organoSicurezzaOriginatore;
    this.documento.organoSicurezzaDestinatario = documentoArrivo.organoSicurezzaDestinatario;
    this.documento.caveatDiSicurezzaId = documentoArrivo.caveatDiSicurezzaId;
    this.documento.caveatDiSicurezzaAltro = documentoArrivo.caveatDiSicurezzaAltro;
    this.documento.modalitaFormazioneId = documentoArrivo.modalitaFormazioneId;
    this.documento.tipoDocumentoId = documentoArrivo.tipoDocumentoId;
    this.documento.ambitoUtilizzoId = documentoArrivo.ambitoUtilizzoId;
    this.documento.numeroControllo = documentoArrivo.numeroControllo;
    this.documento.noCarico = documentoArrivo.noCarico;
    this.documento.numeroEsemplariRicevuti = documentoArrivo.numeroEsemplariRicevuti;
    this.documento.numeroDistintoCopie = documentoArrivo.numeroDistintoCopie;
    this.documento.numeroAllegati = documentoArrivo.numeroAllegati;
    this.documento.copieInCarico = documentoArrivo.copieInCarico;
    this.documento.noteEtichetta = documentoArrivo.noteEtichetta;
    this.documento.dataScadenzaClassifica = documentoArrivo.dataScadenzaClassifica;
    this.documento.scaricaAllegati = documentoArrivo.scaricaAllegati;
    this.documento.sezioneId = documentoArrivo.sezioneId;
    this.documento.riferimento = [{ riferimentoId: documentoArrivo.documentoId } as Riferimento];
    this.documento.documentoDestinatario = [{
      destinatarioId: documentoArrivo.mittenteId
    } as DocumentoDestinatario];
    this.documento.numeroCarico = documentoArrivo.numeroCarico;
  }

  setTrasmettiRiproduzione(riproduzione: DocumentoRiproduzioneRow, documentoArrivo: Documento, dest: Indirizzo[]): void {
    this.documentoRiproduzione = riproduzione;
    this.documentoDaTrasmettere = {
      documentoId: riproduzione.documentoRiproduzioneId!,
      posizioneId: documentoArrivo.posizioneId,
      oggetto: 'Riproduzione - ' + documentoArrivo.oggetto,
      dataDocumento: documentoArrivo.dataDocumento,
      arrivo: false,
      classificaId: documentoArrivo.classificaId,
      classificaOriginaleId: documentoArrivo.classificaOriginaleId || documentoArrivo.classificaId,
      qualificaId: documentoArrivo.qualificaId,
      sezioneId: documentoArrivo.sezioneId,
      esercitazione: documentoArrivo.esercitazione,
      autoreId: documentoArrivo.autoreId,
      ambito: documentoArrivo.ambito,
      lingua: documentoArrivo.lingua,
      paroleChiave: documentoArrivo.paroleChiave,
      documentoAnalogico: documentoArrivo.documentoAnalogico,
      prodottoSoftwareId: documentoArrivo.prodottoSoftwareId,
      numeroPagine: documentoArrivo.numeroPagine,
      organoSicurezzaOriginatore: documentoArrivo.organoSicurezzaOriginatore,
      organoSicurezzaDestinatario: documentoArrivo.organoSicurezzaDestinatario,
      caveatDiSicurezzaId: documentoArrivo.caveatDiSicurezzaId,
      caveatDiSicurezzaAltro: documentoArrivo.caveatDiSicurezzaAltro,
      modalitaFormazioneId: documentoArrivo.modalitaFormazioneId,
      tipoDocumentoId: documentoArrivo.tipoDocumentoId,
      ambitoUtilizzoId: documentoArrivo.ambitoUtilizzoId,
      numeroControllo: documentoArrivo.numeroControllo,
      noCarico: documentoArrivo.noCarico,
      numeroEsemplariRicevuti: documentoArrivo.numeroEsemplariRicevuti,
      numeroDistintoCopie: documentoArrivo.numeroDistintoCopie,
      numeroAllegati: documentoArrivo.numeroAllegati,
      copieInCarico: documentoArrivo.copieInCarico,
      noteEtichetta: documentoArrivo.noteEtichetta,
      dataScadenzaClassifica: documentoArrivo.dataScadenzaClassifica,
      scaricaAllegati: documentoArrivo.scaricaAllegati,
      riferimento: [{ riferimentoId: documentoArrivo.documentoId } as Riferimento]
    } as Documento;
    this.entiRichiedenti = dest;
  }

  // setSpedisciRiproduzione( riproduzione: DocumentoRiproduzioneRow, documentoArrivo: Documento): void {
  //   this.documentoRiproduzione = riproduzione;
  //   this.documentoDaSpedire.documentoId = riproduzione.documentoRiproduzioneId!;
  //   this.documentoDaSpedire.posizioneId = documentoArrivo.posizioneId;
  //   this.documentoDaSpedire.oggetto = 'Riproduzione - ' + documentoArrivo.oggetto;
  //   this.documentoDaSpedire.dataDocumento = documentoArrivo.dataDocumento;
  //   this.documentoDaTrasmettere.arrivo = false;
  //   this.documentoDaSpedire.classificaId = documentoArrivo.classificaId;
  //   this.documentoDaSpedire.qualificaId = documentoArrivo.qualificaId;
  //   this.documentoDaSpedire.sezioneId = documentoArrivo.sezioneId;
  //   this.documentoDaSpedire.riferimento = [{ riferimentoId: documentoArrivo.documentoId } as Riferimento];
  //   this.documentoDaSpedire.documentoDestinatario = [{
  //     destinatarioId: riproduzione.enteRichiedenteId
  //   } as DocumentoDestinatario];
  // }

  setAllegatiDaTrasmettere(allegati: DocumentoAllegato[]): void {
    this.allegatiDaTrasmettere = allegati;
  }
}
